module.exports = __webpack_public_path__ + "img/sample-file.cfb28195.png";